// Webhook n8n qui déclenche l'extraction IA des lots à partir des documents
// d'un chantier (marché, planning...). Même workflow que l'app mobile MyTravo.
// Traitement asynchrone côté n8n : cet appel ne fait que déposer la demande.
import { supabase } from './supabaseClient';

export async function triggerLotUpdateExtraction(chantierId, documentIds) {
  await invokeLotsWorkflow('update-lots', 'Webhook mise à jour lots', chantierId, documentIds);
}

export async function getUpdateSummary(documentIds) {
  if (documentIds.length === 0) return null;

  const { data, error } = await supabase
    .from('chantier_documents')
    .select('extraction_summary')
    .in('id', documentIds)
    .not('extraction_summary', 'is', null)
    .limit(1);

  if (error) throw error;
  return data?.[0]?.extraction_summary ?? null;
}

async function invokeLotsWorkflow(workflow, label, chantierId, documentIds) {
  // L'URL et le secret n8n restent côté serveur (edge function trigger-n8n-workflow).
  const { error } = await supabase.functions.invoke('trigger-n8n-workflow', {
    body: {
      workflow,
      payload: {
        chantier_id: String(chantierId),
        document_ids: documentIds.map(String),
      },
    },
  });

  if (error) {
    let details = '';
    try {
      details = await error.context?.text?.();
    } catch {
      // ignore
    }
    throw new Error(`${label}: ${error.message}${details ? ` ${details}` : ''}`);
  }
}

// Statut d'extraction par document, utilisé pour le polling côté client —
// l'extraction elle-même est asynchrone côté n8n (voir chantier_documents.lot_extraction_status).
export async function getDocumentsStatus(documentIds) {
  if (documentIds.length === 0) return [];

  const { data, error } = await supabase
    .from('chantier_documents')
    .select('id, lot_extraction_status, extraction_error, extracted_at')
    .in('id', documentIds);

  if (error) throw error;
  return data || [];
}

// Réinitialise le statut avant une nouvelle tentative (retry), pour ne pas
// dépendre du timing côté n8n pour effacer l'ancien statut 'error'.
export async function resetDocumentsStatus(documentIds) {
  if (documentIds.length === 0) return;

  const { error } = await supabase
    .from('chantier_documents')
    .update({ lot_extraction_status: 'pending', extraction_error: null })
    .in('id', documentIds);

  if (error) throw error;
}
